export default __webpack_public_path__ + "media/src/assets/images/dunningReportMenu-9059a1a6268f1b4c1973e77bc5cec540.png";